export const Spanish = {
  ok: "De acuerdo",
  loginText: "INGRESAR",
  loginCopyright: "© 2022-2023 Sanerret",
  forgotPassword: "¿Olvidó su contraseña?",
  startEF: "Iniciar - EuroFinance",
  startApp: "Iniciar - Appresta",
  paymentOfFees: "Pago de Cuotas",
  algoVerList: "Lista de versiones de algoritmos",
  emiVerList: "Lista de versiones de Pago de Cuota",
  profile: "Perfil",
  changePassword: "Cambiar contraseña",
  yourPasswordHasBeenchangedSuccessfully:
    "Su contraseña ha sido cambiada con éxito!",
  passwordChanged: "Constraseña cambiada",
  logout: "Cerrar sesión",
  loginAgain: "Ingresar de nuevo",
  ADMIN: "Administrador",
  GENERAL_MANAGER: "Gerente General",
  LOAN_PORTFOLIO_MANAGER: "Gestor de Cartera de Credito",
  COLLECTIONS_OFFICER: "Oficial de Cobros",
  COLLECTIONS_MODERATOR: "Moderador de Cobros",
  CASHIER: "Cajero",
  CLIENT: "Cliente",
  ANALYST: "Analista",
  CONFIGURATOR: "Configurador",
  relationship: "Relación",
  transactionListHistory: "Historial de transacciones",
  graphOfTransactions: "Gráfica de transacciones",
  enterBehaviourCurveValue: "Ingrese el valor de la curva de comportamiento",
  creditScoreUpdatedSuccessfully: "Puntaje de crédito actualizado con éxito",
  update: "Actualizar",
  userManagement: "Gestion de Usuario",
  addUser: "Agregar Usuario",
  image: "Imagen",
  user: "Usuario",
  firstName: "Primer Nombre",
  lastName: "Primer Apellido",
  role: "Tipo",
  userDetails: "Detalles de Usuario",
  profileDetails: "Detalles del Perfil",
  deactivate: "Desactivar",
  deactivateUser: "Desactivar usuario",
  edit: "Editar",
  delete: "Borrar",
  back: "ATRAS",
  cancel: "CANCELAR",
  save: "Guardar",
  status: "Estado",
  saveAsDraft: "GUARDAR COMO BORRADOR",
  saveDraft: "GUARDAR BORRADOR",
  continue: "CONTINUAR",
  submit: "ENVIAR",
  basicInformation: "Datos Básicos",
  loanInformation: "Información del Préstamo",
  fullName: "Nombre Completo",
  name: "Nombres",
  country: "País de Nacimiento",
  telephoneNumber: "Número de telefono  (opcional)",
  phoneNumber: "Número de Teléfono (9 dígitos)",
  email: "Correo electrónico",
  dateOfBirth: "Fecha de Nacimiento",
  address: "Dirección",
  howLongHaveYouLivedAtThatAddress:
    "¿Cuánto tiempo lleva viviendo en esta dirección",
  years: "Años",
  months: "Meses",
  amtReq: "Importe solicitado",
  termRequested: "Plazo Deseado (Seleccione la cantidad primero)",
  howDoYouPlanToUseYourLoan: "Finalidad del Préstamo",
  anotherReason: "Otra Razón",
  repaymentAmount: "Pago de Cuota",
  versionName: "Nombre de la versión",
  backImage: "Imagen Trasera",
  frontImage: "Imagen Frontal",
  additionalInformation: "Información Adicional",
  howLongHaveYouLivedInSpain: "¿Cuánto tiempo lleva viviendo en España?",
  howLongHaveYouLivedAtCurrentAddress:
    "¿Cuánto tiempo lleva viviendo en el domicilio actual? (No puede ser mayor al tiempo de residencia en España.)",
  haveYouHadAFormalOrInformalLoanInThePast6Months:
    "¿Ha tenido préstamos formales o informales en los últimos 6 meses?",
  yes: "Si",
  no: "No",
  company: "Compañía",
  frequencyOfRemittanceSending: "Frecuencia de envíos",
  perMonth: "Por Mes",
  averageAmount: "Importe promedio",
  relationshipToRemittanceReceiver:
    "Relación con el Beneficiario de los envíos",
  give2PersonalReferences: "Referencias Personales (Opcional)",
  reference1: "Referencias 1",
  reference2: "Referencias 2",
  select: "Seleccionar",
  selectVariable: "Seleccione Variable",
  typeOfHousing: "Tipo de vivienda",
  howManyPeopleAreYouFinanciallyResponsibleOf:
    "¿Cuanta gente depende de usted económicamente?",
  toDate: "Hasta",
  fromDate: "Desde",
  enterUserId: "Introduzca ID Unico Cliente Holdco",
  holdcoId: "Holdco Id",
  income: "Ingresos",
  companyName: "Nombre de la empresa o empleador con el que trabaja",
  amountOfSalary: "¿Cuál es su salario/ingreso mensual?",
  howLongHaveYouWorkedThere: "¿Cuánto tiempo lleva trabajando en esta empresa?",
  doYouHaveOtherIncome: "¿Tiene un segundo empleo?",
  doYouHaveAnotherSourceOfIncome: "¿Tiene otros ingresos?",
  source: "Actividad",
  howDoYouGetPaid: "¿Cómo le pagan?",
  directDeposit: "Transferencia en cuenta",
  cash: "Efectivo",
  doYouDepositItOrCashOut: "¿Lo Deposita en su cuenta?",
  deposit: "Lo Deposita",
  cashOut: "Lo Cambia",
  notApplicable: "N/A",
  whatIsYourTotalAverageIncome: "¿Cuál es su ingreso mensual?",
  doYouHaveABankAccount: "¿Tiene cuenta bancaria?",
  nameOfTheBank: "Banco donde desea ingresar el préstamo",
  workingPartner: "¿En caso de convivir en pareja, esta persona trabaja?",
  whatIsTheirMonthlySalary: "¿Cuál es el salario mensual de su pareja?",
  whatIsYourEmploymentSituation: "¿Cuál es su situación laboral?",
  monthlySalary: "Salario Mensual",
  totalIncome: "Totales Ingresos",
  monthlyExpenses: "Gastos Mensuales",
  housingExpenses: "Vivienda",
  carTransportation: "Auto/Transporte",
  phone: "Teléfono",
  amenities: "Servicios básicos (Agua, Luz, Gas, etc)",
  food: "Alimentación",
  medicalBills: "Gastos Medicos",
  otherExpenses: "Otros Personales",
  remittance: "Remesas",
  loanRepaymentOrCreditCardExpenses: "Pago de Préstamo/Tarjetas de Crédito",
  totalExpenses: "Gastos Totales",
  basicDataAndLoanInformation: "Datos Básicos & Información del Préstamo",
  incomeExpensesMonthly: "Ingresos & Gastos Mensuales",
  uploadDocument: "Cargar Documento",
  loanApplication: "Solicitud de préstamo",
  analystApproval: "Aprobación del analista",
  loanDisbursement: "Desembolso del préstamo",
  toAssign: "Asignar",
  assigned: "Asignado",
  confirm: "Confirmar",
  reference: "Referencia",
  document: "Documento",
  negotiation: "Negociación",
  uploadDocuments: "Cargar Documentos",
  viewDocument: "Ver",
  upload: "Grabar",
  browse: "Buscar",
  recentBankStatements: "Extracto bancario mas reciente",
  recentPayStubs: "Dos Recibos De Pago Más Recientes",
  remove: "Borrar",
  downloadReceipt: "Descargar recibo",
  creditAnalysis: "Analisis del Crédito",
  creditScore: "Score de crédito",
  financialSummary: "Resumen Financiero",
  quantityAvailable: "Cantidad Disponible",
  expenses: "Gastos",
  attachments: "Documentos Adjuntos",
  backgroundCheck: "Verificación de Antecedentes",
  addressValidationDocuments: "Validar Domicilio con otros docs (ID, EH)",
  addressValidationReference: "Validación de referencia",
  notes: "Notas",
  addNote: "Agregar Nota",
  referenceCalls: "Llamadas de referencia",
  reference1Validation: "Validación de referencia 1",
  reference2Validation: "Validación de referencia 2",
  negotiationWithClient: "Negociación con el Cliente",
  amountApproved: "Importe Aprobado",
  approvedTerm: "Plazo Aprobado",
  requestedTerm: "Plazo Solicitado",
  addRequest: "Agregar Solicitud",
  myRequests: "Mis solicitudes",
  requests: "Solicitudes",
  statusReport: "Informe de  Aprobaciones",
  CREATED: "Creada",
  APPROVED: "Aprobada",
  INPROCESS: "En proceso",
  PENDING: "Pendiente",
  SUBMITTED: "Enviada",
  REJECTED: "Rechazada",
  INCOMPLETE: "Incompleta",
  DISBURSED: "Desembolsada",
  DISMISSED: "Desestimada",
  january: "Ene",
  february: "Feb",
  march: "Mar",
  april: "Abr",
  may: "May",
  june: "Jun",
  july: "Jul",
  august: "Ago",
  september: "Sep",
  october: "Oct",
  november: "Nov",
  december: "Dic",
  noRecordsFound: "No se encontrarón archivos",
  noData: "Sin Datos",
  doYouWantToDeactivateUser: "¿Quieres desactivar al usuario ?",
  doYouWantToAssignApplicationToYourself:
    "¿Quieres asignarte una aplicación a ti mismo?",
  deleteNoteConfirmation: "¿Quieres borrar esta nota?",
  unsavedDataWillBeLost:
    "¿Los datos no guardados se perderán. Quieres proceder ?",
  submitButtonConfirmationText:
    "¿Seguro que quieres enviar esta solicitud de préstamo?",
  approveButtonConfirmationText:
    "¿Seguro que quieres aprobar esta solicitud de préstamo?",
  rejectButtonConfirmationText:
    "¿Seguro que quieres rechazar esta solicitud de préstamo?",
  disbursedButtonConfirmationText:
    "¿Está seguro de que desea marcar el estado de esta solicitud de préstamo como Desembolsada?",
  incompleteButtonConfirmationText:
    "¿Está seguro de que desea marcar el estado de esta solicitud de préstamo como Incompleto?",
  success: "Éxito",
  loanApplicationCreatedSuccessfully: "Solicitud de préstamo creada con éxito.",
  loanApplicationUpdatedSuccessfully:
    "Solicitud de préstamo actualizada con éxito.",
  documentUploadedSuccessfully: "Documento cargado correctamente.",
  loanApplicationSubmitted: "La  solicitud de prestamo se ha enviado.",
  loanApplicationApproved: "La solicitud de préstamo está aprobada.",
  loanApplicationRejected: "La solicitud de prestamo fue rechazada.",
  loanApplicationIncomplete: "La  solicitud de prestamo esta incompleta.",
  loanDisbursedSuccessfully: "El prestamo ha sido Desembolsada.",
  emailHasBeenSent: "El correo electrónico ha sido enviado.",
  userCreatedSuccessfully: "El usuario ha sido creado con éxito.",
  userUpdatedSuccessfully: "El usuario ha sido actualizado con éxito.",
  noteAddedSuccessfuly: "Nota agregada con éxito.",
  noteUpdatedSuccessfuly: "Nota actualizada con éxito.",
  noteDeletedSuccessfuly: "Nota borrada con éxito.",
  documentRemovedSuccessfully: "Documento eliminado con éxito.",
  addSubtype: "Agregar Subvariable",
  createdBy: "Creado por",
  version: "Editar Versión",
  versionText: "Versión",
  getActive: "Activar",
  editTypeWeight: "Editar peso de variable",
  editSubtypeWeight: "Editar peso de subvariable",
  activate: "Activar",
  reset: "Reiniciar",
  deleteDraft: "Eliminar Borrador",
  getDraft: "Obtener borrador",
  addType: "Agregar Variable",
  emiConfiguration: "configuracion Pago de Cuotas",
  combinedRating: "RATING COMBINADO",
  weight: "Peso",
  set: "Aceptar",
  deleteType: "Eliminar Variable",
  deleteSubType: "Eliminar subvariable",
  add: "Añadir",
  lastModified: "Última modificación",
  enterValueOf: "Editar Variable",
  editSubtype: "Editar Subvariable",
  ACTIVE: "Activo",
  DRAFTED: "Borrador",
  INACTIVE: "Inactivo",
  stayInSpain: "Tiempo de permanencia en España",
  jobTime: "Tiempo de trabajo",
  paymentTotalIncome: "Pago / Ingreso total",
  paymentIncomeMinusExpenses: "Pago / (ingresos totales - Gastos)",
  paymentOtherLoan: "(Pago + Otro préstamo) / Ingreso total",
  addressValidation: "Validación de dirección",
  error: "Error",
  validationByReference: "Validación por referencia",
  Detail: "Detalle",
  Edit: "Editar",
  User: "Usuario",
  Version: "Versión",
  State: "Estados",
  LastModified: "Última modificación",
  activateConfirmationMessage:
    "¿Está seguro de que desea activar esta configuración de puntuación de crédito?",
  getActiveConfirmationMessage:
    "¿Está seguro de que desea activar la configuración de puntaje de crédito?",
  resetConfirmationMessage:
    "¿Está seguro de que desea restablecer los cambios en la configuración de su puntaje de crédito?",
  deleteDraftConfirmationMessage:
    "¿Â¿EstÃ¡ seguro de que desea eliminar eliminar el de esta configuraciÃ³n del puntaje de crÃ©dito ?",
  getDraftConfirmationMessage:
    "¿Sí ha realizado algún cambio, los cambios se perderán. ¿Quieres continuar?",
  saveAsDraftConfirmationMessage:
    "¿Está seguro de que desea guardar esta configuración de puntaje de crédito como borrador?",
  deleteTypeConfirmationMessage:
    "¿Â¿EstÃ¡s seguro de que quieres eliminar esta  variable y su contenido?",
  deleteSubTypeConfirmationMessage:
    "¿Â¿EstÃ¡s seguro de que quieres eliminar esta subvariable?",
  backtotheversionList: "¿Seguro que quieres volver?",
  emailHasNotBeenSent: "El correo electrónico no ha sido enviado.",
  errorEmptyFields: "Los campos obligatorios están vacíos.",
  errorEmptyUserName: "El nombre de usuario está vacío.",
  errorInvalidFirstName: "Nombre no valido.",
  errorInvalidLastName: "Apellido no valido.",
  errorInvalidEmail: "Correo  electronico no valido.",
  errorInvalidDurationInCityAndCOuntry:
    "La duración de la estancia en España no puede ser inferior a la duración de la estancia en la ciudad.",
  errorInvalidUsernameOrPassword: "Usuario o contraseña no valido.",
  errorNewPasswordAndConfirmPasswordAreNotSame:
    "Nueva contraseña y confirmar contraseña no son las mismas.",
  errorInvalidOldPassword: "Contresaña antigua no valida.",
  errorCreateLoanApplication: "No se pudo crear la solicitud de préstamo.",
  errorUpdateLoanApplication: "Solicitud de préstamo no actualizada.",
  errorFileSize: "El tamaño del archivo seleccionado es mayor que 50 MB.",
  errorFileExtension: "Seleccione el archivo de tipo pdf, jpg o jpeg.",
  errorPDFFileExtension: "Seleccione el archivo de tipo pdf.",
  errorImageExtension: "Seleccione el archivo de tipo jpg, jpeg o png.",
  errorNoDocuments: "Por favor cargue todos los documentos.",
  errorUploadDocuments: "Error al cargar el documento.",
  errorRemoveDocument: "No se puede eliminar el documento.",
  errorViewDocument: "No se puede cargar el documento.",
  errorUsernameAlreadyExist: "El nombre de usuario ya existe.",
  errorInvalidSizeAvatar: "Tamaño de la foto no valido.",
  errorEmailIdNotExist: "Correo  electronico no existe.",
  errorGetLoanApplicationById:
    "Error al obtener los detalles de la solicitud de préstamo.",
  errorSaveLoanApplication:
    "No se puede guardar el estado de la solicitud de préstamo.",
  errorApproveLoanApplication:
    "No se puede aprobar el estado de la solicitud de préstamo.",
  errorUpdateLoanApplicationStatus:
    "No se puede actualizar el estado de la solicitud de préstamo.",
  errorSelectManadatoryFields:
    "Por favor seleccione todos los campos obligatorios.",
  errorAddNote: "No se pudo agregar la nota.",
  errorUpdateNote: "Error al actualizar la nota.",
  errorDeleteNote: "Error al eliminar la nota.",
  errorGetAllNotes: "Error al obtener todas las notas.",
  errorAnalysisDataNotFound: "Datos de análisis no encontrados.",
  errorToFetchTheInfoOfId: "No se puede obtener información del cliente",
  errorConfiguration: "Hubo un error",
  errorDraftedNotFound: "Borrador de aloritmo no encontrado",
  errorActiveNotFound: "No encontrado algoritmos activos",
  errorInvalidAlgo: "Cadena de algoritmo no válida",
  errorVersionExists: "Esta versión ya existe",
  errorDraftedExists:
    "No se puede crear un nuevo algoritmo ya que un algoritmo escrito ya existe",
  errorCannotUpdate: "No permitido actualizar ya que no eres el propietario.",
  errorAlgoNotFound: "Configuracion no encontrada ",
  errorAlgoNotDrafted: "El estado del algoritmo no está borrador.",
  InvalidConfigurationData: "Datos de configuracion no validos",
  errorEmptyValue: "El valor de entrada no debe estar vacío.",
  errorAllMappingsAreConfigured: "todas las subvariables están asignadas.",
  errorMappingdosenotMatches: "El mapeo no coincide",
  errorDataNotavailable: "Informacion no disponible",
  versionDataNotAvailable: "Datos de versión no disponibles",
  errorSomethingWentWrong: "Algo salió mal",
  errorHistoryNotFound: "Historial de transacciones no encontrado",
  errorUnableToFetchHistory:
    "No se puede obtener el historial de transacciones",
  successReset: "Los datos de configuracion se restablecieron exitosamente",
  successGetDrafted: "Fetched configuración redactada",
  successGetActive: "Configuración activa captada",
  successSaveAsDraft: "Configuración guardada como borrador",
  successDeleteDraft: "borrador eliminado",
  successActivate: "Configuración activada",
  rate: "Tipo de interes",
  duration: "Plazo",
  emi: "Cuota de pago",
  deleteAmount: "Eliminar Importe",
  addAmount: "Agregar Importe",
  errorDraftedEMIExists:
    "No se puede crear una nueva configuración, ya que ya hay una redactada.",
  errorInvalidEMIConfiguration:
    "Cadena de configuración Pago de Cuota no válida",
  InvalidEMIConfigurationData:
    "Datos de configuración de Pago de Cuota no válidos",
  errorDraftedEMIConfigNotFound:
    "No se ha encontrado ninguna configuración de Pago de Cuota redactada",
  errorEMINotFound: "Configuración Pago de Cuota no encontrada",
  errorEMINotDrafted:
    "El estado de configuración de Pago de Cuota no está redactado",
  invalidEMIConfiguration:
    "La información del préstamo no coincide con la configuración de Pago de Cuota.",
  beneficiaryRelationship: "Relación del beneficiario",
  errorInvalidBehaviorCurveValue: "Valor de curva de comportamiento no válido",
  monthly: "mensual",
  historyFetchedSuccessfully: "Historico obtenido con exito",
  graphFetchedSuccessfully: "Grafirco obtenido con exito",
  activateEMIConfirmationMessage:
    "¿Está seguro de que desea activar esta configuración de Pago de Cuota?",
  getActiveEMIConfirmationMessage:
    "¿Está seguro de que desea obtener la configuración activa de Pago de Cuota?",
  resetEMIConfirmationMessage:
    "¿Está seguro de que desea restablecer los cambios de configuración de Pago de Cuota?",
  deleteDraftEMIConfirmationMessage:
    "¿Está seguro de que desea eliminar la configuración de Pago de Cuota redactada?",
  getDraftEMIConfirmationMessage:
    "¿Sí ha realizado algún cambio, los cambios se perderán. ¿Quieres continuar?",
  saveAsDraftEMIConfirmationMessage:
    "¿Está seguro de que desea guardar esta configuración de Pago de Cuota como borrador?",
  selectUser: "Seleccionar Usuario",
  warningInfinityEmiValue: "Por favor ingrese una duración válida",
  perPage: "por página",
  CSV: "CSV",
  home: "Casa",
  interest: "Interés (%)",
  paid: "Pagado",
  amount: "Importe",
  dueDate: "Fecha de vencimiento ",
  disbursementDate: "Fecha de desembolso",
  loanInfo: "Información del préstamo",
  close: "Cerrar",
  lateFees: "Cargos por pagos atrasados",
  errorLoanApplicationNotFound: "Solicitud de préstamo no encontrada",
  NA: "N/A",
  customerUniqueId: "Holdco Id",
  documentType: "Tipo de Documento",
  documentNumber: "Numero de Identificación (DNI o NIE)",
  documentExpirationDate: "Fecha de vencimiento del documento",
  documentImages: "Imágenes de documentos",
  profession: "Profesión",
  nationality: "País de Nacimiento",
  bankAccountNumber: "Número de cuenta bancaria (24 caracteres)",
  bankStatements: "Extracto Bancario",
  paymentReciepts: "Recibo de pago",
  errorExpiredDocument:
    "El documento estÃ¡ vencido, necesitamos un nuevo documento de identificaciÃ³n para continuar.",
  errorInvalidAmount: "La cantidad debe ser superior a 300",
  errorContinuousRange: "Rango de cantidad no válido.",
  errorAmountOverlap: "El rango de cantidad no debe superponerse.",
  errorZeroValue: "El rango de cantidad no puede comenzar con cero",
  minAmount: "Importe minimo",
  maxAmount: "Importe máximo",
  ReportTo: "Reportar a",
  CASHIER_MODERATOR: "Moderador de Cajeros",
  CUSTOMER_CARE: "Atención al Cliente",
  Reports: "Informes",
  addDocuments: "Agregar documentos",
  "Send money": "Enviar dinero",
  bankAccountDetailsConfirmation:
    "Confirmacion de los detalles de la cuenta bancaria",
  ANALYST_MODERATOR: "Moderador de Analistas",
  switchedDocumentCategory: "Categoría de documento cambiada",
  change: "cambio",
  assign: "asignar",
  saveAnalystInput: "guardar la entrada del analista",
  clientCannotBeCreatedWarning:
    "El cliente no se puede crear/actualizar desde la administración de usuarios",
  sendEmail: "Enviar correo electrónico",
  saveEditedDetails: "Guardar detalles editados",
  reply: "respuesta",
  RESOLVED: "Resuelta",
  addThread: "Agregar hilo de chat",
  resolve: "resolver",
  replied: "Respondido con éxito",
  composed: "Compuesto con éxito",
  resolved: "Resuelto con éxito",
  oldPasswordSameAsNew:
    "La contraseña anterior y la contraseña nueva son las mismas.",
  "Success !": "Éxito !",
  BASIC_INFO: "Información básica",
  ADDITIONAL_INFO: "Información adicional",
  MONTHLY_EXPENSE: "Gastos Mensuales",
  DOCUMENT: "Documentos",
  REFERENCE: "Referencia",
  NEGOTIATION: "Negociación",
  errorValidateFields: "Por favor valide los campos",
  doYouHaveJob: "Tienes trabajo",
  OPERATIONS_OFFICER: "Oficial de Operaciones",
  digitallySigned: "¡El cliente ha firmado el contrato digitalmente!",
  signedInBranch: "¡Se ha firmado contrato en la sucursal!",
  loanAgreement: "Contrato de Prestamo",
  downloadLoanAgreement: "Descargar contrato de préstamo",
  sendloanAgreement: "Enviar contrato de préstamo",
  loanAgreementDetails: "detalles del contrato de préstamo",
  digitally: "Digitalmente",
  offline: "En la sucursal",
  viewContract: "Ver contrato",
  disburse: "Desembolsar",
  uploadLoanAgreement: "Subir contrato de Prestamo",
  applicationId: "ID de Aplicación",
  visitingHours: "Horario de contacto",
  search: "Buscar",
  "Loan Agreement signed at the branch":
    "¡Se ha firmado contrato en la sucursal!",
  "Loan Application not in approved state":
    "Solicitud de préstamo no en estado aprobado",
  "Loan Agreement signature date expired":
    "Fecha de firma del contrato de préstamo vencida",
  "Loan Agreement already signed":
    "Contrato de Prestamo ya fue firmado por el cliente digitalmente!",
  "Loan Agreement not found": "Contrato de préstamo no encontrado",
  acceptAgreementText: "Acepto el contrato de préstamo",
  LEGAL: "Legal",
  W_OFF: "Castigado",
  CLOSED: "Cerrado",
  association: "Asociación",
  createdBY: "Creado por (Cajero/ Moderador de Cajeros)",
  approvedBy: "Aprobado por (Analista / Moderador de Analistas)",
  disbursedBy: "Desembolsada por",
  amortizationTable: "Tabla de Amortización",
  viewLoanApplication: "Ver solicitud de préstamo",
  amountToPay: "Importe a pagar",
  index: "Índice",
  LateFees: "Cargo por Demora ($)",
  amountPaid: "Importe Pagado",
  paymentDates: "Fechas de pago",
  daysInArrears: "Días en Atrasos",
  receipts: "Justificantes",
  note: "Notas",
  disbursementReceipt: "Recibo de Desembolso",
  submissionDate: "Día de entrega",
  loanAgreementSignDate: "Fecha de firma del contrato de préstamo",
  operationOfficerInput: "Entrada del oficial de operaciones",
  viewTransactionReceipt: "Ver recibo de transacción",
  serviceChat: "Chat de Servicio",
  loanPortfolio: "Cartera de préstamos",
  enterData: "Introducir datos",
  Repayment: "Pagos",
  ONLINE: "Online",
  DIRECT_DEBIT: "Domiciliacion bancaria",
  DEBIT_CARD: "Tarjeta de débito",
  CASH: "Efectivo",
  invalidAmount: "Importe no valido",
  pleaseSelectPaymentMethod: "Por favor seleccione el método de pago",
  summaryTable: "Tabla de resumen",
  ndt: "Fecha de Vencimiento Siguiente",
  atc: "Cantidad a Cobrar",
  uc: "Capital Pendiente de Pago",
  ui: "Intereses Pendiente de pago ",
  ulf: "Cargos por Pagos Atrasados",
  paymentMethod: "Método de Pago",
  category: "Categoría",
  arrearsInDays: "Días de Atraso",
  arrearsInDaysOld: "Días en Atrasos",
  balanceToDate: "Saldo hasta la fecha",
  remittanceNo: "Número de remesa",
  transferNo: "Número de transferencia",
  allLateFees: "Todos los cargos por pagos atrasados",
  dt: "Fechas de pago",
  pds: "Fechas de pago",
  c: "Importe del Capital",
  i: "Interés",
  ttl: "Total",
  lf: "Cargo por Demora",
  paymentReceipts: "Recibo subido",
  amountSplitup: "Cantidad dividida",
  invalidTransactionId: "ID de transacción no válido",
  pleaseUploadDocument: "Por favor cargue el documento",
  pm: "Método de Pago",
  "Invalid late fees take off request. Current late fees are less than the requested take off late fees. Discarding this request!":
    "Solicitud de eliminacion de cargos por demora no vÃ¡lida.  Los actuales cargos por demora  son menores que el importe de cargos por demora a eliminar. Â¡Descartando esta solicitud!",
  "Payment amount can not be greater than balance to date":
    "El monto del pago no puede ser mayor que el saldo a la fecha",
  incompleteFieldsWarning:
    "Sí desea marcar esta solicitud como incompleta, también puede seleccionar las casillas de verificación respectivas para los campos con datos incorrectos.",
  termsAndConditions: "Términos y condiciones",
  loanRestructureError:
    "El monto ingresado de la tarifa y el plazo no cubre el monto del saldo vencido.",
  assignNewRepaymentplan: "Asignar un nuevo plan de pago",
  existing: "Existente",
  new: "Nuevo",
  term: "Plazo",
  pleaseFillAllTheFields: "Por favor llene todos los campos",
  accept: "Aceptar",
  count: "Total",
  Remittances: "Remesas",
  MULTI_VALUE: "VALOR MÚLTIPLE",
  RANGE: "RANGO",
  YES_NO: "Sí o No",
  "Annual count of transactions (Avg 2Y)":
    "Recuento anual de transacciones (Avg 2Y)",
  "Annual amount sent/transfered ($) (Avg 2Y)":
    "Importe anual enviado/transferido ($) (promedio de 2 años)",
  "Years as an Europhil client": "Años como cliente de Europhil",
  "Last 5 years behavior curve":
    "Curva de comportamiento de los últimos 5 años",
  birthDate: "Fecha de nacimiento",
  employmentSituation: "Situacion laboral",
  dueLoans: "Para Reembolso",
  NEW: "Nueva",
  selectStatus: "Seleccionar Estado",
  selectCategory: "Seleccionar Categoría",
  LOAN_AUDIT: "Auditoría de préstamos",
  ADMIN_AUDIT: "Auditoría de administrador",
  DISMISS_LOAN: "Descartar préstamo",
  ADDED_NEW_PROFILE_PIC: "Nueva foto de perfil agregada",
  auditTrail: "Log de Auditoría",
  action: "Acción del usuario",
  performerRole: "Rol del ejecutor",
  performer: "Ejecutor",
  performedAt: "Ejecutado en",
  key: "Clave",
  oldData: "Datos anteriores",
  newData: "Datos nuevos",
  ADD_NEW_USER: "Añadir nuevo usuario",
  DATA_MODIFIED: "Datos modificados",
  ACCESS_MODIFIED: "Acceso modificado",
  DEACTIVATED: "Desactivado",
  userName: "Nombre de usuario",
  reportingUserName: "Reporte de nombres de usuario",
  features: "Características",
  selectUserAction: "Seleccionar acción de usuario",
  selectPerformerRole: "Seleccionar rol ejecutor",
  reportingUserRole: "Reporte de roles de usuario",
  ProfilePicChanged: "Foto de perfil actualizada",
  DISMISSED_BY_CLIENT: "por el cliente",
  DISMISSED_BY_TIME: "por tiempo",
  STATE_CHANGED: "Estado cambiado",
  OPERATION_OFFICER_INPUT: "Entrada del oficial de operaciones",
  LOAN_AGREEMENT_SIGNED_OFFLINE: "Contrato de préstamo firmado sin conexión",
  SEND_LOAN_AGREEMENT_MANUALLY: "Enviar contrato de préstamo manualmente",
  ANALYST_INPUT: "Entrada del analista",
  ASSIGNED_TO: "Asignado a",
  RECENT_BANK_STATEMENT_ADDED: "Extracto bancario reciente añadido",
  state: "Estado",
  documentSubType: "Subtipo de documento",
  total: "Total",
  housing: "Vivienda",
  validAddr: "Dirección válida",
  emiApproved: "Aprobado por EMI",
  termApproved: "Plazo Aprobado",
  accountVerified: "Cuenta verificada",
  interestApproved: "Interés Aprobado",
  trmReq: "Plazo Deseado (Seleccione la cantidad primero)",
  loanUse: "Finalidad del Préstamo",
  interestRate: "Interés (%)",
  BASIC_DATA: "Datos Básicos",
  LOAN_INFO_DATA: "Información del Préstamo",
  INCOME_DATA: "Ingresos",
  EXPENSES_DATA: "Gastos",
  ADDITIONAL_INFORMATION_DATA: "Información Adicional",
  sectionType: "Tipo de Sección",
  RECENT_PAY_STUBS_ADDED: "Talones de pago recientes añadidos",
  selectAuditType: "Selecciona tipo de auditoría",
  performedOn: "Ejecutado en",
  LOGIN: "Ingresar",
  LOGOUT: "Cerrar Sesión",
  FORGOT_PASSWORD: "¿Olvidó su contraseña?",
  CHANGE_PASSWORD: "Cambiar contraseña",
  CONFIGURATOR_AUDIT: "Auditoría de configurador",
  ACTIVATED: "Activada",
  PAYMENT_RECEIVED: "Pago recibido",
  NOTE_ADDED: "Nota añadida",
  clientUniqueId: "Holdco Id",
  maturityDate: "Fecha de vencimiento",
  telephoneNumber2: "Número de telefono  (opcional)",
  ref1Name: "Referencia 1 nombre",
  ref2Name: "Referencia 2 nombre",
  bankNameForIncome: "Banco donde desea ingresar el préstamo",
  transactionId: "ID de transacción",
  amountCollected: "Cantidad recaudada",
  DISBURSEMENT: "Desembolso",
  TRANSACTION: "Transacción",
  validRef1: "Validación de referencia 1",
  validRef2: "Validación de referencia 2",
  validByRef: "Validación por referencia",
  behaviorCurve: "Curva de comportamiento",
  type: "Tipo",
  clientVerified: "Cliente verificado",
  year: "Año",
  month: "Mes",
  to: "A",
  from: "De",
  isExists: "Existe",
  src: "Actividad",
  employmentSituationJob1: "¿Cuál es su situación laboral?",
  job1: "Trabajo 1",
  job2: "Trabajo 2",
  employed: "Empleado",
  partnerWork: "¿En caso de convivir en pareja, esta persona trabaja?",
  partnerSalary: "Salario de socio",
  job1DurationMonths: "¿Cuánto tiempo lleva trabajando en esta empresa1?",
  job2DurationMonths: "¿Cuánto tiempo lleva trabajando en esta empresa2?",
  subType: "Subtipo",
  eurStay: "¿Cuánto tiempo lleva viviendo en España?",
  madridStay:
    "¿Cuánto tiempo lleva viviendo en el domicilio actual? (No puede ser mayor al tiempo de residencia en España.)",
  hr: "hora",
  min: "min",
  INCOME_PROOF: "Prueba de ingresos",
  RECENT_PAY_STUBS: "Talones de pago recientes",
  RECENT_BANK_STATEMENT: "Estado de banco reciente",
  LOAN_AGREEMENT_SIGNED_ONLINE: "Contrato de préstamo firmado en línea",
  STATUS_CHANGED: "Estado cambiado",
  SYSTEM: "Sistema",
  details: "Detalles",
  true: "Si",
  false: "No",
  "Fixed contract": "Contrato fijo",
  "Temporary contract": "Contrato temporal",
  "Self employed": "Por cuenta propia",
  "Unemployed with benefit": "Desempleado con prestación",
  "Unemployed without benefit": "Desempleado sin prestación",
  Father: "Padre",
  Mother: "Madre",
  Son: "Hijo/a",
  Sibling: "Hermano/a",
  Friend: "Amigo/a",
  Uncle: "Tío/a",
  Grandfather: "Abuelo/a",
  "Other family member": "Otro miembro de la familia",
  BoyFriend: "Novio/a",
  Other: "Otros",
  LATE_FEES_ADDED: "Tarifa añadida",
  LATE_FEES_REMOVED: "Cargo retrasado eliminado",
  "Own with mortgage": "Propia con hipoteca",
  "Own without mortgage": "Propia sin hipoteca",
  "Rent housing": "Alquiler vivienda",
  "Rental room": "Alquiler habitación",
  "House of a relative": "Casa de un familiar",
  others: "Otros",
  lateFeeAmount: "Cargos por pagos atrasados",
  selectPerformerType: "Seleccione el tipo de intérprete",
  USER: "Usuario",
  RESET_USER_CREDENTIAL: "Resetear credenciales de usuario",
  salary: "¿Cuál es su salario/ingreso mensual?",
  payMode: "¿Cómo le pagan?",
  phn: "Teléfono",
  other: "Otros Personales",
  loanCredit: "Pago de Préstamo/Tarjetas de Crédito",
  carTransport: "Auto/Transporte",
  checkProcessing: "¿Lo Deposita en su cuenta?",
  ref1: "Referencias 1",
  ref2: "Referencias 2",
  remitFreq: "Frecuencia de envíos",
  housingType: "Tipo de vivienda",
  accountNumber: "Número de cuenta bancaria (24 caracteres)",
  typeOfStreet: "Tipo de Calle",
  addressStreet: "Nombre de la calle",
  addressStreet2: "Dirección Calle 2",
  addressProvince: "Dirección Provincia",
  addressPostalCode: "Dirección Código Postal",
  username: "Nombre de usuario",
  houseNo: "Número de casa",
  bankName: "Banco donde desea ingresar el préstamo",
  lastName1: "Apellido 1",
  lastName2: "Apellido 2",
  visitTime: "Horario de contacto",
  addressCity: "Dirección Ciudad",
  remitRelation: "Relación con el Beneficiario de los envíos",
  anotherIncome: "¿Tiene otros ingresos?",
  payState: "Estado de pago",
  lateRepay: "Último reembolso",
  finResponsible: "¿Cuanta gente depende de usted económicamente?",
  formalInformalLoan:
    "¿Ha tenido préstamos formales o informales en los últimos 6 meses?",
  YES: "Sí",
  NO: "No",
  "Repair of a vehicle": "Reparación de un vehículo",
  Cash: "Efectivo",
  Deposit: "Lo Deposita",
  exists: "Existe",
  " Buy a car / motorbike": "Comprar un coche /moto",
  "Leisure or travel": "Ocio o Viajes",
  Celebrations: "Celebraciones",
  "Education or training": "Educación o formación",
  "Dental or medical expenses": "Dental o Gastos médicos",
  "Unify debts": "Unificar deudas",
  "Furniture, reforms or home equipment":
    "Muebles, reformas o equipamiento hogar",
  "Direct deposit": "Transferencia en cuenta",
  liveDataSuccessRequest:
    "Su solicitud de datos archivados ha sido creada correctamente. Recibirás un email con la información solicitada", //
  liveData: "Datos actuales",
  dateRangeErrorForLiveData:
    "Por favor, selecciona un rango de datos",
  archievedData: "Datos archivados",
  generateAudit: "Generar Auditoría",
  selectYear: "Seleccione año",
  "Request already raised.":
    "Solicitud ya planteada. Intente despues de 24 horas.",
  archievedDataSuccess:
    "Su solicitud de datos archivados ha sido creada correctamente. Recibirás un email con la información solicitada",
  pleaseSelectYear: "Por favor seleccione año",
  branchName: "Nombre de la sucursal",//
  branchCode: "Código de sucursal",//
  provincia : "Provincia",//
  branchInformation: "Información sucursal",//
  RECENT_PAY_STUBS: "Talones de pago recientes",
  RECENT_PAY_STUBS_REMOVED: "Talones de pago recientes eliminado",
  RECENT_BANK_STATEMENT: "Estado de banco reciente",
  RECENT_BANK_STATEMENT_REMOVED: "Extracto bancario reciente eliminado",
  BRANCH_INFO: "Información sucursal",
};
